import clsx from 'clsx';

import Button, { type ButtonProps } from './Button';
import s from './Button.module.scss';

const ButtonOutlined = ({ className, ...props }: ButtonProps) => (
  <Button className={clsx(s.outlined, className)} {...props} />
);

export default ButtonOutlined;
